<template lang="pug">
.activity-screenshot
  template(v-if="activity")
    .label-project-name(
      v-tooltip="{ placement: 'top', html: true }"
      :title="projectNamesTooltip"
    )
      | {{ allProjectNames }}
    .task-name(
      v-if="hasTaskSummaries"
      v-tooltip="{ placement: 'top', html: true }"
      :title="allTaskSummaries"
    )
      | {{ allTaskSummaries }}
    .task-name.text-superlight(v-else) No {{ organizationTaskPlural }}

    .top-shot-body-no-hover(v-if="isPlanLimited")
      .shot-body.no-actions.fs-exclude
        .screenshot-activity-overlay
          .screenshots-limit-achieved-overlay
            p.screenshots-limit-achieved
              i.hi.hi-lock.text-blue
              strong.small.text-white
                | Limit reached
          a.btn.btn-sm.btn-outline-default.slot-view.overlay-content.shot.no-action.screenshots-limit-achieved-link(
            v-if="canUpgradePlan"
            @click.prevent="goToPlansPage"
          )
            | Upgrade
          a.btn.btn-sm.btn-outline-default.slot-view.overlay-content.shot.no-action.screenshots-limit-achieved-link(
            v-else-if="canViewUpgradePlanInfo"
            disabled="disabled"
            title="Contact your Organization owner to upgrade plans"
          )
            | Upgrade
        .state_shot.enforce-limits_blured-data(v-if="screenshot")
          img.no-action(:data-lazy-src="screenshot.thumb_url")
          .state-shot-wrapper
            i.hi.hi-screenshot
            div
              template(v-if="proxyUser") Screenshot hidden
              template(v-else) Screenshot deleted

    .top-shot-body-no-hover(
      v-else-if="shouldShowScreenshot"
      @click="showGallery"
    )
      .shot-body.no-actions.fs-exclude
        .screenshot-activity-overlay
          a.btn.btn-sm.btn-outline-default.slot-view.overlay-content.shot.no-action
            | View screen
        .state_shot(v-if="screenshot")
          img.no-action(:data-lazy-src="screenshot.thumb_url")
    .top-shot-body-no-hover(v-else)
      .shot-body.no-actions.no-screenshot.fs-exclude
        .state_shot.no_screenshot
          .state-shot-wrapper
            i.hi.hi-screenshot
            div
              template(v-if="proxyUser") Screenshot hidden
              template(v-else) Screenshot deleted
    .meta
      .meta-head
        .meta-interval {{ recordedAt }}
      AppGalleryItem.hidden(
        v-if="shouldShowScreenshot"
        :url="screenshot.original_url"
        :thumb-url="screenshot.thumb_url"
        :caption="screenshot.short_caption"
      )
  template(v-else)
    .top-shot-body-no-hover
      .shot-body.no-actions.no-screenshot.fs-exclude
        .state_shot.no_screenshot
          .state-shot-wrapper
            i.hi.hi-screenshot
            div No screenshots
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { formatTime, parseInternalDatetime } from '~/utils/time_utils';

export default {
  name: 'ActivitiesScreenshot',
  inject: ['$appGallery'],
  props: {
    screenshot: {
      type: Object,
    },
    activity: {
      type: Object,
    },
    observer: {
      type: IntersectionObserver,
      required: true,
    },
  },
  computed: {
    ...mapState({
      proxyUser: (state) => state.proxy_user,
    }),
    ...mapGetters(['currentZone', 'organizationTaskPlural']),
    recordedAt() {
      return formatTime(parseInternalDatetime(this.screenshot.recorded_at), { timezone: this.currentZone.name });
    },
    projectNames() {
      return this.activity.project_names || [];
    },
    projectNamesTooltip() {
      const projectNames = this.projectNames.map((projectName) => HubstaffUtils.escapeHTML(projectName));

      return projectNames.join('<br/>');
    },
    allProjectNames() {
      return this.projectNames.join(', ');
    },
    taskSummaries() {
      return (this.activity && this.activity.task_summaries && this.activity.task_summaries.split(', ')) || [];
    },
    taskSummariesTooltip() {
      const taskSummaries = this.taskSummaries.map((taskSummary) => HubstaffUtils.escapeHTML(taskSummary));

      return taskSummaries.join('<br/>');
    },
    allTaskSummaries() {
      return this.taskSummaries && this.taskSummaries.join(', ');
    },
    isPlanLimited() {
      return this.screenshot.plan_limited;
    },
    hasTaskSummaries() {
      return this.taskSummaries && this.taskSummaries.length > 0;
    },
    hasScreen() {
      return !!this.screenshot;
    },
    hasScreenshot() {
      return this.screenshot && !this.screenshot.deleted;
    },
    shouldShowScreenshot() {
      return this.hasScreenshot && !this.proxyUser;
    },
    permissions() {
      return this.activity && this.activity.permissions;
    },
    canUpgradePlan() {
      return this.activity.upgrade_plan_button_state === 'enabled';
    },
    canViewUpgradePlanInfo() {
      return this.activity.upgrade_plan_button_state === 'disabled';
    },
  },
  mounted() {
    this.observer.observe(this.$el);
  },
  methods: {
    showGallery() {
      if (this.hasScreenshot) {
        this.$appGallery.openItemByIndex(this.screenshot.index);
      }
    },
    goToPlansPage() {
      window.open(this.activity.upgrade_plan_url, '_blank');
    },
  },
};
</script>
